import { ChangeDetectionStrategy, Component } from '@angular/core';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-footer',
  template: `
  <div class="container-fluid text-center text-body fw-light fs-6">
    <div>{{appName}} (powered by <a href="{{datalabUrl}}" target="_blank" rel="noopener">DataLab</a>)</div>
    <div>Copyright Stryker © 2014-{{year}}</div>
  </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class FooterComponent {
  /**
   * Current year.
   */
  protected readonly year: number = new Date().getFullYear();
  /**
   * Application display name.
   */
  protected readonly appName = environment.appName;
  /**
   * DataLab Portal UI URL.
   */
  protected readonly datalabUrl = environment.dl.homepage;
}
